import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

/** Input for toggling the account-level Hockey Canada integration. */
export interface SetHockeyCanadaIntegrationInput {
  /** Account uid the integration belongs to */
  accountUid: string
  /** Desired state — true enables, false disables */
  enabled: boolean
}

/**
 * Enables or disables the Hockey Canada integration for an account.
 *
 * Enable and disable are separate endpoints (mirroring USA Hockey) rather than
 * a single PUT with a body — see `ENDPOINTS.ACCOUNT`.
 *
 * The resulting state is reflected on the account payload at
 * `integrations.hockeycanada.is_enabled`, so callers should refetch the
 * account afterwards rather than trusting a local copy.
 */
export const setHockeyCanadaIntegration = async ({
  accountUid,
  enabled,
}: SetHockeyCanadaIntegrationInput): Promise<void> => {
  if (!accountUid) {
    throw new Error(
      'accountUid is required to update the Hockey Canada integration'
    )
  }

  const url = enabled
    ? ENDPOINTS.ACCOUNT.ENABLE_HOCKEY_CANADA_INTEGRATION(accountUid)
    : ENDPOINTS.ACCOUNT.DISABLE_HOCKEY_CANADA_INTEGRATION(accountUid)

  await req(url, { method: 'PUT' })
}
